module.exports = __webpack_public_path__ + "static/media/edit-icon.9a7f9559.svg";